/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * For young drivers there may be an accompanying person.   (german: begleitende Person)
 */
export interface AccompanyingPerson {
  /**
   * This is a reference to a partner. The partner must be contained in the list of partners and must have a matching *partnerId*.
   */
  partnerId?: string;
}
